import { Col, ComponentLoader, HorizontalRule, Modal, Row } from '@snsw/react-component-library';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { PagePath } from 'shared/constants/pagePath';
import { NavigationButtons } from '@onegov/react-component-library';
import style from './buttons.module.scss';
import { store } from 'shared/redux/configureStore';

import { UserPasswordlessManager } from 'shared/oidc/passwordLessUserManager';

import { clearApplication, createApplication, saveApplication, storeCurrentPath } from 'shared/redux/applicationSlice';
import { clearForm, clearPlantDesignForm, storeRedirect } from 'plantItemNew/redux/slices/formSlice';
import { clearPlantDesignReferenceData } from 'plantDesign/redux/plantDesignReferenceDataSlice';

export const PasswordlessContinueSaveExitButtons = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [showErrorModal, setErrorShowModal] = useState(false);
  const [emailAddress, setEmailAddress] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const location = useLocation();
  const application = useSelector((state) => state.application);

  const { onContinueClick, onBackClick } = props;

  const confirmExit = () => {
    setShowModal(false);
    let redirectUrl = PagePath.plantDesignApplicationById.replace(':id', application.applicationId);

    setIsLoading(true);

    UserPasswordlessManager.instance().stopSilentRenew();

    dispatch(clearForm());
    dispatch(clearPlantDesignForm());
    dispatch(clearPlantDesignReferenceData());
    dispatch(clearApplication());
    dispatch(storeRedirect(redirectUrl));
    UserPasswordlessManager.instance().signoutRedirect();
  };

  const cancelExit = () => {
    setShowModal(false);
  };

  const save = async () => {
    if (props.onPreSaving) {
      props.onPreSaving();
    }

    store.dispatch(storeCurrentPath(location.pathname));

    if (!application?.applicationId) {
      await store.dispatch(createApplication(props.licenceType));
    }

    try {
      var resp = await store.dispatch(saveApplication(true)).unwrap();
      setEmailAddress(resp.emailSentTo);
      setShowModal(true);
    } catch {
      setErrorShowModal(true);
    }
  };

  useEffect(() => {
    if (application.error) setErrorShowModal(true);
  }, [application.error]);

  return (
    <>
      <HorizontalRule />

      <div className={style.continueSaveExitContainer}>
        <NavigationButtons
          leftButtonConfig={{
            label: 'Continue',
            onClick: onContinueClick,
          }}
          rightButtonConfig={{
            label: 'Save and exit',
            onClick: save,
          }}
          backButtonConfig={{
            onClick: onBackClick,
            isVisible: onBackClick ? true : false,
          }}
        />
      </div>

      {showModal && (
        <Modal
          title="Your progress has been saved."
          description={'Continue this application at anytime by using the link sent to ' + emailAddress}
          buttons={[
            { text: 'Back to Service NSW', onClick: confirmExit },
            { text: 'Continue Registration', onClick: cancelExit },
          ]}
        />
      )}
      {showErrorModal && (
        <Modal
          title="Fail to save your application"
          description={'Please try again'}
          buttons={[
            {
              text: 'OK',
              onClick: () => {
                setErrorShowModal(false);
              },
            },
          ]}
        />
      )}
      {(application.savingApplication || isLoading) && (
        <Row>
          <Col span={12}>
            <ComponentLoader fullPage />
          </Col>
        </Row>
      )}
    </>
  );
};

PasswordlessContinueSaveExitButtons.propTypes = {
  onContinueClick: PropTypes.func.isRequired,
  onPreSaving: PropTypes.func,
  onBackClick: PropTypes.func,
  licenceType: PropTypes.string.isRequired,
};
